// extracted by mini-css-extract-plugin
export default {"root":"textBox_root__5-FU9","rootFocused":"textBox_rootFocused__Bj9IQ"};